import fixture from './SendCompanyRegistrationEmail.post.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ISendCompanyRegistrationEmailClient,
} from 'interfaceAdapter/gatewaySchemas/ISendCompanyRegistrationEmailClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/company/send_registration_email`;

export class SendCompanyRegistrationEmailClient implements ISendCompanyRegistrationEmailClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { email, valuation_estimate_info, mock = false } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({
            email,
            ...(valuation_estimate_info && { valuation_estimate_info }),
        });
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                      body,
                  });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
